import { format } from 'date-fns';
import awaitWrap from '../../../../procedures/await-wrap.js';
import modelId from '../../../../procedures/model-id.js';
import signDocument from '../../../../procedures/sign-document.js';
import action from '../../../abstract/action.js';
import { signStatusOptions } from '../index';

const handle = async (
  {
    $vs,
    item: {
      id,
      agreement,
      agreement_original,
    },
    model: {
      api: {
        store,
        storeSignerToken,
      },
    },
    reloadList,
  },
) => {
  const response = await storeSignerToken({ id });
  const { document, token } = response.data;

  const padesResponse = await signDocument({
    $vs,
    format: 'pades',
    document,
    token,
  });

  await store({
    agreement: modelId(agreement),
    agreement_original: modelId(agreement_original),
    content: padesResponse.data['signed'],
    sign_status: signStatusOptions.onlyMe.value,
    signed_at: format(new Date(), 'yyyy-MM-dd hh:mm:ss'),
  });

  await awaitWrap(reloadList)();
};

export default action({
  label: 'Podpisz',
  icon: 'CheckSquareIcon',
  main: ({ item }) => item.sign_status === signStatusOptions.none.value,
  render: ({ item }) => isRendered(item),
  handle,
});

function isRendered(item) {
  return item.sign_status !== signStatusOptions.bothSign.value;
}
